<template>
  <a v-if="link && link != ''" :href="link" target="_blank">
    <div :style="getWidgetStyle()" v-html="getTags().start + content + getTags().end">
    </div>
  </a>
  <a v-else-if="post && post != ''" v-on:click="WidgetUtils.post(post)">
    <div :style="getWidgetStyle()" v-html="getTags().start + content + getTags().end">
    </div>
  </a>
  <a v-else-if="download && download != ''" :href="WidgetUtils.renderLinkWithArgs(download)">
    <div :style="getWidgetStyle()" v-html="getTags().start + content + getTags().end">
    </div>
  </a>
  <a v-else-if="modal && modal != ''" v-on:click="WidgetUtils.modal(modal)">
    <div :style="getWidgetStyle()" v-html="getTags().start + content + getTags().end">
    </div>
  </a>
  <div v-else :style="getWidgetStyle()" v-html="getTags().start + content + getTags().end">
  </div>
</template>
<script>
import WidgetUtils from '../utils/WidgetUtils'
export default {
  props: ['content', 'font', 'lineheight', 'letterspacing', 'size', 'color', 'align', 'link', 'post', 'download', 'modal', 'role'],
  data () {
    return {
      WidgetUtils: WidgetUtils
    }
  },
  methods: {
    getWidgetStyle: function () {
      var self = this
      return 'font-family:' + self.font + ';font-size:' + self.size + 'px;color:' + self.color + ';line-height:' + self.lineheight + ';letter-spacing:' + self.letterspacing + 'px;text-align:' + (self.align == 'fulljustifylastlineleft' ? 'justify' : self.align) + ';'
    },
    getTags: function () {
      var self = this
      var style = 'margin:0;padding:0;font-size:inherit !important;line-height:inherit !important;'
      var tagName = 'p'
      if (self.role !== undefined && self.role !== null && self.role !== '') {
        tagName = self.role
      }
      return {start: '<' + tagName + ' style="' + style + '">', end: '</' + tagName + '>'}
    }
  }
}
</script>
<style lang="scss" scoped>
h1{
  font-size: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/TextWidget.vue